import {Component, Event, EventEmitter, Fragment, h, Host, Prop, State} from '@stencil/core';

import "@bun-ui/icons";
import "@bun-ui/modals";
import "@bun-ui/layout";
import "@bun-ui/links";
import "@bun-ui/formatter";
import "@bun-ui/markdown-renderer";
import "@bun-ui/form-components";

@Component({
  tag: 'lb-accounttype-select',
  styleUrl: "styles.scss",
  shadow: true,
})
export class AccountTypeSelect {

  /**
   * a href to "Zurück zur Beschreibung" next to submit button
   */
  @Prop({reflect: true}) backLink: string;

  /**
   * shows when there is nothing selected
   */
  @Prop()error = false;

  /**
   * Eventemitter for "zur Antragsstellung" button
   * Results in eventEmitter
   * @returns {EventEmitter<string>} with possible values: "buerger" and "organisation"
   */
  @Event() zurAntragsstellung: EventEmitter<string>;

  // "meta" texts in selected language
  @Prop({ mutable: true }) i18n;

  /**
   * selected account type from radio select
   */
  @State() selectedAccountType:  null | 'buerger' | 'organisation';

  render() {
    return (
      <Host>
        <div>          
          <c-header type="h2" role="heading" data-testid="accounttype-select-title">
              {this.i18n?.beantragung?.accountTypeSelectHeadline}
          </c-header>
          <c-text>
            <c-markdown-renderer>
              <div slot="source">
                  {this.i18n?.beantragung?.accountTypeSelectText}
              </div>
            </c-markdown-renderer>
          </c-text>
          {this.i18n?.beantragung?.accountTypeSelectLabel && (
            <Fragment>
              <h4>{this.i18n?.beantragung?.accountTypeSelectLabel}</h4>
              <a-radiogroup
                data-testid="accounttype-select-radio-buttons"
                aria-describedby="accounttype-select-error-text"
                aria-invalid={this.error}
                data={["buerger", "organisation"]}
                labels={{
                  "buerger": this.i18n?.beantragung?.accountTypeSelectOptionBuerger,
                  "organisation": this.i18n?.beantragung?.accountTypeSelectOptionOrganisation
                }}
                onValuechange={({detail}) => {
                  if (!!detail) {
                    this.selectedAccountType = detail;
                  }
                }}
                ></a-radiogroup>
              </Fragment>
            )}
          {this.error && (<div id="accounttype-select-text-error" class="text-error" role="alert">{this.i18n?.beantragung?.accountTypeSelectError}</div>)}
          <br/>
          <br/>
          <br/>
          <div class="controls">
            {this.backLink && <c-text>
              <c-link centered href={this.backLink}>
                {this.i18n?.beantragung?.accountTypeSelectBackBtn}
              </c-link>
            </c-text>}
            <c-button data-testid="accounttype-select-proceed-button"
                primary large centered-content
                onClick={() => {
                  if (this.selectedAccountType) {
                    this.error = false;
                    this.zurAntragsstellung.emit(this.selectedAccountType);
                  } else {
                    this.error = true;
                  }
                }}>{this.i18n?.beantragung?.accountTypeSelectProceedBtn}
            </c-button>
          </div>
        </div>
      </Host>
    );
  }
}